import { EMAIL_FIELD, FIRST_NAME_FIELD, LAST_NAME_FIELD } from "./generic.fields"

const FIELD_OF_WORK = [
	{
		label: "Air Force",
		value: "AIR FORCE"
	},
	{
		label: "Businessman",
		value: "BUSINESS PERSON"
	},
	{
		label: "Cameraman",
		value: "CAMERAMAN"
	},
	{
		label: "Charity/Social Worker",
		value: "CHARITY/SOCIAL WORKER"
	},
	{
		label: "Chartered Accountant",
		value: "CHARTERED ACCOUNTANT"
	},
	{
		label: "College/University Teacher",
		value: "COLLEGE/UNIVERSITY TEACHER"
	},
	{
		label: "Defence",
		value: "DEFENCE"
	},
	{
		label: "Diplomat",
		value: "DIPLOMAT"
	},
	{
		label: "Doctor",
		value: "DOCTOR"
	},
	{
		label: "Engineer",
		value: "ENGINEER"
	},
	{
		label: "Film Producer",
		value: "FILM PRODUCER"
	},
	{
		label: "Government Service",
		value: "GOVERNMENT SERVICE"
	},
	{
		label: "House Wife",
		value: "HOUSE WIFE"
	},
	{
		label: "Journalist",
		value: "JOURNALIST"
	},
	{
		label: "Labour",
		value: "LABOUR"
	},
	{
		label: "Lawyer",
		value: "LAWYER"
	},
	{
		label: "Media",
		value: "MEDIA"
	},
	{
		label: "Military",
		value: "MILITARY"
	},
	{
		label: "Missionary",
		value: "MISSIONARY"
	},
	{
		label: "Navy",
		value: "NAVY"
	},
	{
		label: "News Broadcaster",
		value: "NEWS BROADCASTER"
	},
	{
		label: "Official",
		value: "OFFICIAL"
	},
	{
		label: "Others",
		value: "OTHERS"
	},
	{
		label: "Paramilitary",
		value: "PARAMILITARY"
	},
	{
		label: "Police",
		value: "POLICE"
	},
	{
		label: "Press",
		value: "PRESS"
	},
	{
		label: "Private Service",
		value: "PRIVATE SERVICE"
	},
	{
		label: "Publisher",
		value: "PUBLISHER"
	},
	{
		label: "Reporter",
		value: "REPORTER"
	},
	{
		label: "Researcher",
		value: "RESEARCHER"
	},
	{
		label: "Retired",
		value: "RETIRED"
	},
	{
		label: "Seaman",
		value: "SEA MAN"
	},
	{
		label: "Security",
		value: "SECURITY"
	},
	{
		label: "Self-employed/ Freelancer",
		value: "SELF EMPLOYED/ FREELANCER"
	},
	{
		label: "Student",
		value: "STUDENT"
	},
	{
		label: "Trader",
		value: "TRADER"
	},
	{
		label: "TV Producer",
		value: "TV PRODUCER"
	},
	{
		label: "Unofficial",
		value: "UN OFFICIAL"
	},
	{
		label: "Worker",
		value: "WORKER"
	},
	{
		label: "Writer",
		value: "WRITER"
	}
]

const MAPPED_GATES = {
	air: [
		{
			label: "Ahmedabad Airport",
			value: "I022"
		},
		{
			label: "Amritsar Airport",
			value: "I032"
		},
		{
			label: "Bagdogra Airport",
			value: "I096"
		},
		{
			label: "Bengaluru Airport",
			value: "I085"
		},
		{
			label: "Bhubaneswar Airport",
			value: "I084"
		},
		{
			label: "Calicut Airport",
			value: "I010"
		},
		{
			label: "Chandigarh Airport",
			value: "I005"
		},
		{
			label: "Chennai Airport",
			value: "I008"
		},
		{
			label: "Cochin Airport",
			value: "I024"
		},
		{
			label: "Coimbatore Airport",
			value: "I094"
		},
		{
			label: "Delhi Airport",
			value: "I004"
		},
		{
			label: "Gaya Airport",
			value: "I012"
		},
		{
			label: "Goa Airport(Dabolim)",
			value: "I033"
		},
		{
			label: "Goa Airport (Mopa)",
			value: "I034"
		},
		{
			label: "Guwahati Airport",
			value: "I019"
		},
		{
			label: "Hyderabad Airport",
			value: "I041"
		},
		{
			label: "Indore Airport",
			value: "I017"
		},
		{
			label: "Jaipur Airport",
			value: "I006"
		},
		{
			label: "Kannur Airport",
			value: "I030"
		},
		{
			label: "Kolkata Airport",
			value: "I002"
		},
		{
			label: "Lucknow Airport",
			value: "I021"
		},
		{
			label: "Madurai Airport",
			value: "I015"
		},
		{
			label: "Mangalore Airport",
			value: "I092"
		},
		{
			label: "Mumbai Airport",
			value: "I001"
		},
		{
			label: "Nagpur Airport",
			value: "I016"
		},
		{
			label: "Port Blair Airport",
			value: "I077"
		},
		{
			label: "Pune Airport",
			value: "I026"
		},
		{
			label: "Surat Airport",
			value: "I029"
		},
		{
			label: "Tiruchirapalli Airport",
			value: "I003"
		},
		{
			label: "Trivandrum Airport",
			value: "I023"
		},
		{
			label: "Varanasi Airport",
			value: "I007"
		},
		{
			label: "Vishakhapatnam Airport",
			value: "I025"
		}
	],
	sea: [
		{
			label: "Chennai Seaport",
			value: "I208"
		},
		{
			label: "Cochin Seaport",
			value: "I224"
		},
		{
			label: "Goa Seaport",
			value: "I283"
		},
		{
			label: "Mangalore Seaport",
			value: "I293"
		},
		{
			label: "Mumbai Seaport",
			value: "I201"
		},
		{
			label: "Port Blair Seaport",
			value: "I277"
		}
	]
}

export const IN_FIELDS = {
	human_trafficking: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	cyber_crime_espionage: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	terrorist: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	refused: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	pakistan_nationals_relatives: {
		answer: {
			type: "yes-no-buttons"
		},
		details: {
			type: "input",
			props: {
				label: "Details"
			}
		}
	},
	employment_status: {
		relationship: {
			type: "select",
			props: {
				label: "Relationship",
				options: [
					{ label: "Mother", value: "mother" },
					{ label: "Father", value: "father" },
					{ label: "Spouse", value: "spouse" }
				]
			}
		},
		military: {
			answer: {
				type: "yes-no-buttons"
			},
			organization: {
				type: "name-field",
				props: {
					label: "Employer",
				 maxLength: 50
				}
			},
			position: {
				type: "name-field",
				props: {
					label: "Position",
				 maxLength: 50
				}
			},
			rank: {
				type: "name-field",
				props: {
					label: "Rank",
				 maxLength: 50
				}
			},
			location: {
				type: "input",
				props: {
					label: "Place of Service",
				 maxLength: 50
				}
			}
		},
		different_field: {
			answer: {
				type: "yes-no-buttons"
			},
			field: {
				type: "select",
				props: {
					label: "Previous Field of Work",
					options: FIELD_OF_WORK
				}
			},
			field_details: {
				type: "input",
				props: {
					label: "Field of Work",
				 maxLength: 50
				}
			}
		},
		field: {
			type: "select",
			props: {
				label: "Field of Work",
				options: FIELD_OF_WORK
			}
		},
		field_details: {
			type: "input",
			props: {
				label: "Field of Work",
			 maxLength: 50
			}
		}
	},
	reference: {
		first_name: FIRST_NAME_FIELD,
		last_name: LAST_NAME_FIELD,
		company_name: {
			type: "name-field",
			props: {
				label: "Company Name"
			},
		},
		address: {
			address_1: {
				type: "input",
				props: {
					label: "Street Address",
				 maxLength: 40
				},
			},
			city: {
				type: "input",
				props: {
					label: "City",
				 maxLength: 28
				}
			},
			zip: {
				type: "input",
				props: {
					label: "Zip",
					"pattern": "[0-9]{6}",
				 maxLength: 6
				}
			},
			state: {
				type: "in-state"
			},
			district: {
				type: "in-district",
				props: {
					parentKey: 'in.reference.address.state'
				}
			}
		},
		phone_number: {
			type: "masked-input",
			props: {
				mask: "00 000 000-0000",
				label: "Phone Number"
			}
		},
		website: {
			type: "input",
			props: {
				label: "Website",
				"pattern": "(https?://)?(www\\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)",
			 maxLength: 255
			},
			"className": "gwc-form__field gwc-form__field--grow",
			"validation": {
				"messages": {
				 maxLength: "Your email must be less than 34 characters."
				}
			}
		}
	}
}

export const IN_APPLICATION_FIELDS = {
	business_invitation_letter: {
		props: { 
			type: "pdf_document", 
			"message": "Please take a picture of the business invitation letter.", 
			"friendly_name": "Bsuiness Invitation Letter" 
		}
	},
	conference: {
		name: {
			type: "name-field",
			props: {
				label: "Name of the conference"
			}
		},
		start_date: {
			type: "datepicker",
			props: {
				label: "From",
				view: "multi-year",
				after: [
					{
						date: "now",
						message: "Date can't be in the past."
					}
				],
				before: [
					{
						key: "application.in.conference.end_date",
						parent: "global",
						message: "Date must be before the end date."
					}
				]
			}
		},
		end_date: {
			type: "datepicker",
			props: {
				label: "To",
				view: "multi-year",
				after: [
					{
						date: "now",
						message: "Date can't be in the past."
					},
					{
						key: "application.in.conference.start_date",
						parent: "global",
						message: "Date must be after the start date."
					}
				]
			}
		},
		organizer: {
			email: EMAIL_FIELD,
			phone_number: {
				type: "masked-input",
				props: {
					mask: "00 000 000-0000",
					label: "Phone Number"
				}
			},
			name: {
				type: "name-field",
				props: {
					label: "Name of the organizer"
				}
			},
			address: {
				address_1: {
					type: "input",
					props: {
						label: "Address",
						maxLength: 50
					}
				}
			}
		},
		address: {
			address_1: {
				type: "input",
				props: {
					label: "Address",
					maxLength: 40
				}
			},
			zip_code: {
				type: "input",
				props: {
					label: "Zip Code",
					pattern: "[0-9]{6}",
					maxLength: 6
				}
			},
			state: {
				type: "in-state"
			},
			district: {
				type: "in-district"
			}
		}
	},
	purpose: {
		type: "select",
		props: {
			label: "Purpose of Visit",
			options: [
				{
					label: "Tourism/Sightseeing",
					value: "tourist"
				},
				{
					label: "Meeting with friends or relatives",
					value: "friends-relatives"
				},
				{
					label: "Short term yoga programs",
					value: "yoga"
				},
				{
					label: "Short term courses on local language, music, dance, etc. Courses should be less than 6 months.",
					value: "stshort-term-coursesdy"
				},
				{
					label: "Volunteering (no more than 1 month)",
					value: "volunteer"
				},
				{
					label: "Setup of business in India",
					value: "business-venture-setup"
				},
				{
					label: "Sale, purchase, or trade",
					value: "sale-purchase-trade"
				},
				{
					label: "Attend business meeting",
					value: "business-meeting"
				},
				{
					label: "Recruitment",
					value: "recruitment"
				},
				{
					label: "Exhibition or trade fair",
					value: "exhibition-fair"
				},
				{
					label: "Religious activities",
					value: "religious-activities"
				},
				{
					label: "Specialist for an on-going project",
					value: "specialist-ongoing-project"
				},
				{
					label: "Conducting Business Tours",
					value: "tours"
				},
				{
					label: "Deliver lecture under Global Initiative for Academic Networks (GIAN)",
					value: "deliver-lecture-gian"
				},
				{
					label: "E-Productivion investment",
					value: "e-production-investment"
				},
				{
					label: "Sports",
					value: "sports"
				},
				{
					label: "Join the Vessel",
					value: "join-the-vessel"
				},
				{
					label: "Attending a conference",
					value: "conference"
				}
			]
		}
	},
	yoga_program: {
		institute: {
			type: "name-field",
			props: {
				label: "Institute Name"
			}
		},
		address: {
			type: "input",
			props: {
				label: "Address"
			}
		},
		state: {
			type: "in-state"
		},
		district: {
			type: "in-district",
			props: {
				parentKey: 'application.in.yoga_program.state'
			}
		},
		phone_number: {
			type: "masked-input",
			props: {
				mask: "00 000 000-0000",
				label: "Phone Number"
			}
		}
	},
	tours: {
		agency: {
			name: {
				type: "input",
				props: {
					label: "Name of the Travel Agency",
					maxLength: 50
				}
			},
			address: {
				type: "input",
				props: {
					label: "Address of the Travel Agency",
					maxLength: 100
				}
			}
		},
		cities: {
			list: {
				type: "multiple",
				"fieldArray": {
					"fieldGroup": [
						{
							"key": "city",
							type: "input",
							props: {
								label: "City",
								"pattern": "^[a-zA-Z\\s\\-']*$",
								"required": true
							},
							"className": "gwc-form__field gwc-form__field--grow",
							"validation": {
								"messages": {
									"pattern": "Please use only letters, spaces, dashes and apostrophes."
								}
							}
						}
					]
				},
				"defaultValue": [
					null
				]
			}
		},
		associate: {
			name: {
				type: "input",
				props: {
					label: "Name of the Travel Agent/Associate",
					maxLength: 50
				}
			},
			address: {
				type: "input",
				props: {
					label: "Address of the Travel Agent/Associate",
					maxLength: 100
				}
			},
			phone_number: {
				type: "masked-input",
				props: {
					mask: "00 000 000-0000",
					label: "Phone Number"
				}
			}
		}
	},
	vessel: {
		name: {
			type: "input",
			props: {
				label: "Name of the Vessel",
				maxLength: 50
			}
		},
		type: {
			type: "select",
			props: {
				label: "Type of the Vessel",
				options: [
				{
					label: "Cargo Vessel (Merchant Navy)",
					value: "CARGO VESSEL (MERCHANT NAVY)"
				},
				{
					label: "Passenger Or Cruise Ship",
					value: "PASSENGER OR CRUISE SHIP"
				},
				{
					label: "Research Vessel",
					value: "RESEARCH VESSEL"
				},
				{
					label: "Fishing Trawler",
					value: "FISHING TRAWLER"
				},
				{
					label: "Navy Vessel",
					value: "NAVY VESSEL"
				},
				{
					label: "Other",
					value: "OTHERS"
				}
				]
			}
		},
		type_other: {
			type: "input",
			props: {
				label: "Please Specify the Type of the Vessel",
				maxLength: 50
			}
		},
		port_of_entry: {
			type: "select",
			props: {
				label: "Port of Entry",
				options: [
				{
					label: "Agatti Seaport",
					value: "AGATTI SEAPORT"
				},
				{
					label: "Alang Seaport",
					value: "ALANG SEAPORT"
				},
				{
					label: "Bedi Bandar Seaport",
					value: "BEDI BANDAR SEAPORT"
				},
				{
					label: "Bhavnagar Seaport",
					value: "BHAVNAGAR SEAPORT"
				},
				{
					label: "Calicut Seaport",
					value: "CALICUT SEAPORT"
				},
				{
					label: "Chennai Seaport",
					value: "CHENNAI SEAPORT"
				},
				{
					label: "Cochin Seaport",
					value: "COCHIN SEAPORT"
				},
				{
					label: "Cuddalore Seaport",
					value: "CUDDALORE SEAPORT"
				},
				{
					label: "Dahej Seaport",
					value: "DAHEJ SEAPORT"
				},
				{
					label: "Dhamra Seaport",
					value: "DHAMRA SEAPORT"
				},
				{
					label: "Goa Seaport",
					value: "GOA SEAPORT"
				},
				{
					label: "Haldia Seaport",
					value: "HALDIA SEAPORT"
				},
				{
					label: "Hazira Seaport",
					value: "HAZIRA SEAPORT"
				},
				{
					label: "Kakinada Seaport",
					value: "KAKINADA SEAPORT"
				},
				{
					label: "Kamarajar Seaport",
					value: "KAMARAJAR SEAPORT"
				},
				{
					label: "Kandla Seaport",
					value: "KANDLA SEAPORT"
				},
				{
					label: "Karaikal Seaport",
					value: "KARAIKAL SEAPORT"
				},
				{
					label: "Kattupali Seaport",
					value: "KATTUPALI SEAPORT"
				},
				{
					label: "Kolkata Seaport",
					value: "KOLKATA SEAPORT"
				},
				{
					label: "Kollam Seaport",
					value: "KOLLAM SEAPORT"
				},
				{
					label: "Krishnapatnam Seaport",
					value: "KRISHNAPATNAM SEAPORT"
				},
				{
					label: "Mandvi Seaport",
					value: "MANDVI SEAPORT"
				},
				{
					label: "Mangalore Seaport",
					value: "MANGALORE SEAPORT"
				},
				{
					label: "Mumbai Seaport",
					value: "MUMBAI SEAPORT"
				},
				{
					label: "Mundra Seaport",
					value: "MUNDRA SEAPORT"
				},
				{
					label: "Nagapattinam Seaport",
					value: "NAGAPATTINAM SEAPORT"
				},
				{
					label: "Nhava Sheva Seaport",
					value: "NHAVA SHEVA SEAPORT"
				},
				{
					label: "Paradeep Seaport",
					value: "PARADEEP SEAPORT"
				},
				{
					label: "Pipavav Seaport",
					value: "PIPAVAV SEAPORT"
				},
				{
					label: "Porbandar Seaport",
					value: "PORBANDAR SEAPORT"
				},
				{
					label: "Port Blair Seaport",
					value: "PORT BLAIR SEAPORT"
				},
				{
					label: "Sikka Seaport",
					value: "SIKKA SEAPORT"
				},
				{
					label: "Tuna Tekra Seaport",
					value: "TUNA TEKRA SEAPORT"
				},
				{
					label: "Tuticorin Seaport",
					value: "TUTICORIN SEAPORT"
				},
				{
					label: "Vallarpadam Seaport",
					value: "VALLARPADAM SEAPORT"
				},
				{
					label: "Vishakhapatnam Seaport",
					value: "VISHAKHAPATNAM SEAPORT"
				},
				{
					label: "Vizhinjam International Seaport",
					value: "VIZHINJAM INTERNATIONAL SEAPORT"
				},
				{
					label: "Vizhinjam Seaport",
					value: "VIZHINJAM SEAPORT"
				}
				]
			}
		},
		boarding_date: {
			type: "datepicker",
			props: {
				view: "multi-year",
				label: "Date You Will Board the Vessel",
				after: [
					{
						date: "now",
						message: "Date can't be in the past."
					}
				]
			}
		},
		position: {
			type: "input",
			props: {
				label: "Rank/Position/Designation on the Ship",
				maxLength: 50
			}
		},
		shipping_agent: {
			name: {
				type: "input",
				props: {
					label: "Name of the Shipping Agent",
					maxLength: 50
				}
			},
			address: {
				type: "input",
				props: {
					label: "Address",
					maxLength: 50
				}
			},
			state: {
				type: "in-state"
			},
			district: {
				type: "in-district",
				props: {
					parentKey: 'application.in.vessel.shipping_agent.state'
				}
			}
		}
	},
	exit_type: {
		type: "select",
		props: {
			label: "Exit Type",
			options: [
				{
					label: "Air",
					value: "air"
				},
				{
					label: "Sea",
					value: "sea"
				}
			]
		}
	},
	entry_type: {
		type: "select",
		props: {
			label: "Entry Type",
			options: [
				{
					label: "Air",
					value: "air"
				},
				{
					label: "Sea",
					value: "sea"
				}
			]
		}
	},
	date_of_entry: {
		type: "datepicker",
		props: {
			view: "multi-year",
			after: [
				{
					date: "now",
					message: "Date can't be in the past."
				}
			],
			before: [
				{
					operation: "add",
					months: 4,
					message: "Departure date has to be within 4 months from today."
				},
				{
					key: "passport.expiry_date",
					parent: "global",
					operation: "subtract",
					months: 6,
					message: "Date of Entry must be more than 6 months before passport expiry."
				}
			],
			label: "Date of Entry"
		}
	},
	entry_gate: {
		type: 'mapped-select',
		props: {
			label: "Gate of Entry",
			parentKey: 'application.in.entry_type',
			mappedOptions: MAPPED_GATES
		}
	},
	exit_gate: {
		type: 'mapped-select',
		props: {
			label: "Gate of Exit",
			parentKey: 'application.in.exit_type',
			mappedOptions: MAPPED_GATES
		}
	},
	cities_to_visit: {
		list: {
			type: "multiple",
			"fieldArray": {
				"fieldGroup": [
					{
						"key": "city",
						type: "input",
						props: {
							label: "City",
							"pattern": "^[a-zA-Z\\s\\-']*$",
						 maxLength: 28,
							"required": true
						},
						"className": "gwc-form__field gwc-form__field--grow",
						"validation": {
							"messages": {
								"pattern": "Please use only letters, spaces, dashes and apostrophes."
							}
						}
					}
				]
			},
			"defaultValue": [
				null
			]
		}
	},
	previous_visits: {
		answer: {
			type: "yes-no-buttons"
		},
		address: {
			type: "input",
			props: {
				label: "Address",
				"pattern": "^[^'&]*$",
			 maxLength: 90
			},
			"validation": {
				"messages": {
					"pattern": "Please do not use apostrophes or ampersands."
				}
			}
		},
		visa_number: {
			type: "input",
			props: {
				label: "Visa Number",
				pattern: "^[A-Za-z0-9]+$",
				maxLength: 10
			}
		},
		visa_type: {
			type: "select",
			props: {
				label: "Type of Visa",
				options: [
					{
						label: "Ayush Visa",
						value: "161"
					},
					{
						label: "Business Visa",
						value: "1"
					},
					{
						label: "Conference Visa",
						value: "4"
					},
					{
						label: "Diplomatic Visa",
						value: "11"
					},
					{
						label: "Double Entry",
						value: "87"
					},
					{
						label: "Employment Visa",
						value: "9"
					},
					{
						label: "Entry Visa",
						value: "6"
					},
					{
						label: "E-Visa",
						value: "100"
					},
					{
						label: "Film Visa",
						value: "84"
					},
					{
						label: "Journalist Visa",
						value: "8"
					},
					{
						label: "Medical Visa",
						value: "16"
					},
					{
						label: "Missionary Visa",
						value: "7"
					},
					{
						label: "Mountaineering Visa",
						value: "63"
					},
					{
						label: "Official Visa",
						value: "12"
					},
					{
						label: "Pilgrimes Visa",
						value: "64"
					},
					{
						label: "Student Visa",
						value: "2"
					},
					{
						label: "Tourist Visa",
						value: "3"
					},
					{
						label: "Transit Visa",
						value: "5"
					},
					{
						label: "UN Diplomat",
						value: "86"
					},
					{
						label: "UN Official",
						value: "17"
					},
					{
						label: "Visit Visa",
						value: "76"
					}
				]
			}
		},
		place_of_issue: {
			type: "name-field",
			props: {
				label: "Place of Issue",
				"pattern": "^[A-Za-z]+(?: [A-Za-z]+)*$",
			 maxLength: 30
			},
			"validation": {
				"messages": {
					"pattern": "Please use only letters and spaces."
				}
			}
		},
		date_of_issue: {
			type: "datepicker",
			props: {
				"view": "multi-year",
				label: "Date of Issue",
				"before": [
					{
						"date": "now",
						"message": "Date can't be in the future."
					}
				]
			}
		},
		cities_visited: {
			list: {
				type: "multiple",
				"fieldArray": {
					"fieldGroup": [
						{
							"key": "city",
							type: "input",
							props: {
								label: "City",
								"pattern": "^[a-zA-Z\\s\\-']*$",
								"required": true
							},
							"className": "gwc-form__field gwc-form__field--grow",
							"validation": {
								"messages": {
									"pattern": "Please use only letters, spaces, dashes and apostrophes."
								}
							}
						}
					]
				},
				"defaultValue": [
					null
				]
			}
		}
	},
	visited_kongo_uganda_south_sudan_21: {
		answer: {
			type: "yes-no-buttons"
		}
	}
}